var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pages",
    class: _vm.theme
  }, [_c('div', {
    staticClass: "fruitRushPage page",
    class: _vm.isMobile && 'wap',
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/inset-bg-1.jpg`)})`
    }
  }, [_c('div', {
    staticClass: "game-box"
  }, [_c('div', {
    staticClass: "game-top-box relative flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex gap-10"
  }, [_c('div', {
    staticClass: "bg-rounded"
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Level')))]), _c('div', {
    staticClass: "text-xl font-bold"
  }, [_vm._v(_vm._s(_vm.gameState.level))])])]), _c('div', {
    staticClass: "gap-10"
  }, [_c('div', {
    staticClass: "time-box"
  }, [_c('div', {
    staticClass: "time-count flex items-center gap-10",
    class: _vm.gameState.timeLeft <= 10 ? 'text-red-500 animate-pulse' : ''
  }, [_c('img', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "src": require(`@images/${_vm.theme}/time.png`),
      "alt": "time"
    }
  }), _vm._v(_vm._s(_vm._f("formatHour")(_vm.gameState.timeLeft)))])])]), _c('div', [_c('div', {
    staticClass: "bg-rounded"
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Score')))]), _c('div', {
    staticClass: "text-xl font-bold text-green",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.gameState.score))])])])]), _c('div', {
    staticClass: "game-progress-box"
  }, [_c('div', {
    staticClass: "transition-all duration-300 progress-bg"
  }, [_c('div', {
    staticClass: "progress-bar bg-green-500",
    style: `width: ${Math.min(100, _vm.gameState.score / _vm.gameState.targetScore * 100)}%`
  })]), _c('div', {
    staticClass: "progress-text flex justify-between"
  }, [_c('span', [_vm._v("Match fruits to gain time!")]), _c('span', [_vm._v("Target: " + _vm._s(_vm.gameState.targetScore))])])]), _c('div', {
    staticClass: "game-center-box flex relative flex-1 items-center justify-center"
  }, [_c('div', {
    staticClass: "relative grid game-bg",
    style: {
      gridTemplateColumns: `repeat(${_vm.GRID_SIZE}, 1fr)`,
      width: 'min(90vw, 400px)',
      height: 'min(90vw, 400px)'
    }
  }, [_vm._l(_vm.flatGrid, function (tile) {
    return _c('div', {
      key: tile?.id || `empty-${tile.row}-${tile.col}`,
      class: ['relative flex items-center justify-center text-3xl cursor-pointer', 'transition-all duration-200 transform tile-pop ',
      // 选中效果
      _vm.gameState.selectedTile && _vm.gameState.selectedTile.row === tile.row && _vm.gameState.selectedTile.col === tile.col ? 'scale-110 bg-white bg-opacity-50 z-10 shadow-lg' : '',
      // hint 效果
      _vm.isHint(tile.row, tile.col) ? 'ring-2 ring-yellow-400 ring-opacity-80' : '',
      // tile 存在与否
      tile ? 'opacity-100 scale-100' : 'opacity-0 scale-50'],
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      on: {
        "click": function ($event) {
          return _vm.handleTileClick(tile.row, tile.col);
        }
      }
    }, [tile?.type ? _c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/game/fruitRush/${tile?.type}.png`),
        "alt": ""
      }
    }) : _vm._e()]);
  }), _vm.isShuffling ? _c('div', {
    staticClass: "absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center z-20 backdrop-blur-sm animate-pulse"
  }, [_c('span', {
    staticClass: "text-4xl mb-2"
  }, [_vm._v("🔄")]), _c('span', {
    staticClass: "text-xl font-bold uppercase tracking-widest"
  }, [_vm._v("Shuffling...")])]) : _vm._e()], 2)]), _c('div', {
    staticClass: "game-bottom-box relative flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex gap-10"
  }, [_c('div', {
    staticClass: "bg-white/80 rounded"
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Total Score')))]), _c('div', {
    staticClass: "text-xl font-bold text-blue",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.totalScore))])])]), _c('div', {
    staticClass: "gap-10"
  }, [_c('div', {
    staticClass: "time-box"
  }, [_c('div', {
    staticClass: "time-count"
  }, [_vm._v(_vm._s(_vm._f("formatHour")(_vm.leftTime)))]), _c('div', {
    staticClass: "time-text"
  }, [_vm._v(_vm._s(_vm.$lang('Award and reset after countdown.')))])])]), _c('div', [_c('div', {
    staticClass: "bg-white/80 rounded",
    on: {
      "click": _vm.viewRank
    }
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Prize Pool')))]), _c('div', {
    staticClass: "text-xl font-bold text-green",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/earn-key.png`),
      "width": "18",
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.prizePool))])])])])])]), _c('pop-game-warn-prompt', {
    attrs: {
      "show": _vm.popOpenMobileShow,
      "message": _vm.$lang(`Please open this page on your mobile phone.`),
      "btnConfirmText": _vm.$lang('Back')
    },
    on: {
      "update:show": function ($event) {
        _vm.popOpenMobileShow = $event;
      },
      "confirm": function ($event) {
        return _vm.$router.back();
      }
    }
  }), _c('pop-game-start-prompt', {
    attrs: {
      "show": _vm.popStartShow,
      "message": _vm.$lang(`<li>Earn rewards by playing.</li>
<li>The higher your rank, the greater your reward.</li>
<li>You can play multiple times before the leaderboard countdown ends.</li>
<li>Only your highest score will be counted on the leaderboard.</li>
<li>When the countdown ends, all players will be reset and a new ranking will begin.</li>
`)
    },
    on: {
      "update:show": function ($event) {
        _vm.popStartShow = $event;
      },
      "confirm": function ($event) {
        return _vm.restartGame();
      }
    }
  }), _c('pop-game-user-reward-prompt', {
    attrs: {
      "show": _vm.popUserRewardShow,
      "title": _vm.$lang('Congratulations')
    },
    on: {
      "update:show": function ($event) {
        _vm.popUserRewardShow = $event;
      },
      "confirm": _vm.handleGetRewardConfirm
    }
  }), _c('pop-game-win-prompt', {
    attrs: {
      "show": _vm.popWinShow,
      "title": _vm.$lang('Congratulations'),
      "message": _vm.$lang(`You completed the level ${_vm.gameState.level}`),
      "nextLevel": _vm.gameState.level + 1,
      "nextBtnText": _vm.nextBtnText
    },
    on: {
      "update:show": function ($event) {
        _vm.popWinShow = $event;
      },
      "confirm": _vm.startNextLevel
    }
  }), _c('pop-game-lost-prompt', {
    attrs: {
      "show": _vm.popLostShow,
      "title": _vm.$lang('Time\'s Up!'),
      "message": _vm.$lang('So close!<br>Watch a short ad to get 30 more seconds and push for a higher score on the leaderboard!'),
      "cancelText": _vm.$lang('Restart (Score Resets)'),
      "confirmText": _vm.revives > 0 ? _vm.$lang(`Continue (+${_vm.ADV_PLAY_TIME}s) (${_vm.revives}/${_vm.maxRevives})`) : _vm.$lang('Restart')
    },
    on: {
      "update:show": function ($event) {
        _vm.popLostShow = $event;
      },
      "cancel": _vm.handleCancel,
      "confirm": _vm.handleConfirm
    }
  }), _c('pop-game-user-reward-prompt', {
    attrs: {
      "show": _vm.popUserRewardShow,
      "title": _vm.$lang('Congratulations')
    },
    on: {
      "update:show": function ($event) {
        _vm.popUserRewardShow = $event;
      },
      "confirm": _vm.handleGetRewardConfirm
    }
  }), _c('pop-game-rank', {
    attrs: {
      "gameType": 'fruitRush',
      "show": _vm.popGameRankShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popGameRankShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };